import React from 'react';
import { Card } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const Categories = () => (
  <>
    <Card.Group itemsPerRow={3} stackable>
      <Card
        as={Link}
        to="/information"
        image="https://twr360.net/pages/from-despair-to-hope/information.jpg"
        header="Information"
      />
      <Card
        as={Link}
        to="/inspiration"
        image="https://twr360.net/pages/from-despair-to-hope/inspiration.jpg"
        header="Inspiration"
      />

      <Card
        as={Link}
        to="/instruction"
        image="https://twr360.net/pages/from-despair-to-hope/instruction.jpg"
        header="Instruction"
      />
    </Card.Group>
  </>
);

export default Categories;
